import titleStatus from '../../../assets/json-administration-profiles/availableTitleStatus.json';

function useTitleStatus() {
	return {
		options: titleStatus,
	};
}

export default useTitleStatus;
